const json = [{
    img: require("./assets/logos/2x/vechain.png"),
    label: 'vechain',
    linkLabel: 'vechain.org'
  },
  {
    img: require("./assets/logos/2x/ontology.png"),
    label: 'ontology',
    linkLabel: 'ont.io'
  },
  {
    img: require("./assets/logos/2x/mxc2.png"),
    label: 'mxc',
    linkLabel: 'mxc.org'
  },
  // {
  //   img: require("./assets/logos/2x/scry.png"),
  //   label: 'scry',
  //   linkLabel: 'scry.info'
  // },
  {
    img: require("./assets/logos/2x/quarkchain.png"),
    label: 'quarkchain',
    linkLabel: 'quarkchain.io'
  },
  {
    img: require("./assets/logos/2x/medishares.png"),
    label: 'medishares',
    linkLabel: 'medishares.org'
  },
  {
    img: require("./assets/logos/2x/metadium.png"),
    label: 'metadium',
    linkLabel: 'metadium.com'
  },
  {
    img: require("./assets/logos/2x/primas.png"),
    label: 'primas',
    linkLabel: 'primas.io'
  },
  {
    img: require("./assets/logos/2x/gxchain.png"),
    label: 'gxchain',
    linkLabel: 'gxb.io'
  },
  {
    img: require("./assets/logos/2x/kyber.png"),
    label: 'kyber',
    linkLabel: 'kyber.network'
  },
  // {
  //   img: require("./assets/logos/2x/baic.png"),
  //   label: 'baic',
  //   linkLabel: 'baic.io'
  // },
  // {
  //   img: require("./assets/logos/2x/tenx.png"),
  //   label: 'tenx',
  //   linkLabel: 'tenx.tech'
  // },
  {
    img: require("./assets/logos/2x/rsk.png"),
    label: 'rsk',
    linkLabel: 'rsk.co'
  },
  // {
  //   img: require("./assets/logos/2x/poet.png"),
  //   label: 'poet',
  //   linkLabel: 'po.et'
  // },
  {
    img: require("./assets/logos/2x/status.png"),
    label: 'status',
    linkLabel: 'status.im'
  },
  {
    img: require("./assets/logos/2x/sharespost.png"),
    label: 'sharespost',
    linkLabel: 'sharespost.com'
  },
  {
    img: require("./assets/logos/2x/hashgraph.png"),
    label: 'hashgraph',
    linkLabel: 'hashgraph.com'
  },
  {
    img: require("./assets/logos/2x/topnetwork.png"),
    label: 'topnetwork',
    linkLabel: 'topnetwork.org'
  },
  {
    img: require("./assets/logos/2x/nucypher.png"),
    label: 'nucypher',
    linkLabel: 'nucypher.com'
  },
  {
    img: require("./assets/logos/2x/celer.png"),
    label: 'celer',
    linkLabel: 'celer.network'
  },
  {
    img: require("./assets/logos/2x/certik.png"),
    label: 'certik',
    linkLabel: 'certik.org'
  },
  {
    img: require("./assets/logos/2x/reserve.png"),
    label: 'reserve',
    linkLabel: 'reserve.org'
  },
  {
    img: require("./assets/logos/2x/oceanex.png"),
    label: 'oceanex',
    linkLabel: 'oceanex.pro'
  },
  // {
  //   img: require("./assets/logos/2x/everitoken.png"),
  //   label: 'everitoken',
  //   linkLabel: 'everitoken.io'
  // },
  {
    img: require("./assets/logos/2x/platon.png"),
    label: 'platon',
    linkLabel: 'platon.io'
  },
  {
    img: require("./assets/logos/2x/beosin.png"),
    label: 'beosin',
    linkLabel: 'beosin.io'
  },
  {
    img: require("./assets/logos/2x/circle.png"),
    label: 'circle',
    linkLabel: 'circle.com'
  },
  {
    img: require("./assets/logos/2x/abra.png"),
    label: 'abra',
    linkLabel: 'abra.com'
  },
  {
    img: require("./assets/logos/2x/symbiont.png"),
    label: 'symbiont',
    linkLabel: 'symbiont.io'
  },
  {
    img: require("./assets/logos/2x/everledger.png"),
    label: 'everledger',
    linkLabel: 'everledger.io'
  },
  {
    img: require("./assets/logos/2x/parity.png"),
    label: 'parity',
    linkLabel: 'parity.io'
  },
  {
    img: require("./assets/logos/2x/blockone.png"),
    label: 'block.one',
    linkLabel: 'block.one'
  },
  {
    img: require("./assets/logos/2x/bloq.png"),
    label: 'bloq',
    linkLabel: 'bloq.com'
  },
  {
    img: require("./assets/logos/2x/clearmatics.png"),
    label: 'clearmatics',
    linkLabel: 'clearmatics.com'
  },
  {
    img: require("./assets/logos/2x/theblock.png"),
    label: 'theblock',
    linkLabel: 'theblockcrypto.com'
  },
  // {
  //   img: require("./assets/logos/2x/factom.png"),
  //   label: 'factom',
  //   linkLabel: 'factom.com'
  // },
  {
    img: require("./assets/logos/2x/messari.png"),
    label: 'messari',
    linkLabel: 'messari.io'
  },
  {
    img: require("./assets/logos/2x/dfinity.png"),
    label: 'dfinity',
    linkLabel: 'dfinity.org'
  },
  {
    img: require("./assets/logos/2x/polkadot.png"),
    label: 'polkadot',
    linkLabel: 'polkadot.network'
  },
  {
    img: require("./assets/logos/2x/zcash.png"),
    label: 'z.cash',
    linkLabel: 'z.cash',
    scaleNum: 1.3
  },
  {
    img: require("./assets/logos/2x/madhive.png"),
    label: 'madhive',
    linkLabel: 'madhive.com',
    scaleNum: 1.1
  },
  {
    img: require("./assets/logos/2x/bloxroute.png"),
    label: 'bloXroute',
    linkLabel: 'bloxroute.com'
  },
  {
    img: require("./assets/logos/2x/enigma.png"),
    label: 'enigma',
    linkLabel: 'enigma.co'
  },
  // {
  //   img: require("./assets/logos/2x/wanglu.png"),
  //   label: 'wanglu',
  //   linkLabel: 'wanglutech.com'
  // },
  // {
  //   img: require("./assets/logos/2x/bbj.png"),
  //   label: 'bbj',
  //   linkLabel: 'bbj.ai'
  // },
  {
    img: require("./assets/logos/2x/taraxa.png"),
    label: 'taraxa.io',
    linkLabel: 'taraxa.io',
    scale: .9
  },
  {
    img: require("./assets/logos/2x/hashquark.png"),
    label: 'hashquark',
    linkLabel: 'hashquark.io',
    scaleNum: 1.6
  },
  //new add
  {
    img: require("./assets/logos/2x/filecoin.png"),
    label: 'filecoin',
    linkLabel: 'filecoin.io',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/Keep_logo_black.png"),
    label: 'tBtc(keep)',
    linkLabel: 'keep.network',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/ChainSafe.png"),
    label: 'chainSafe',
    linkLabel: 'chainsafe.io',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/bubi.png"),
    label: 'bubi',
    linkLabel: 'bubi.cn',
    scaleNum: 1.25
  },
  {
    img: require("./assets/logos/2x/chainx.png"),
    label: 'chainX',
    linkLabel: 'chainx.org',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/Vidy.png"),
    label: 'vidy',
    linkLabel: 'vidy.com',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/blockstack.png"),
    label: 'blockStack',
    linkLabel: 'blockstack.org',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/vim.png"),
    // label: 'VIM World（Playtable）',
    label: 'vim world',
    linkLabel: 'vimworld.com',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/1475IPFS.png"),
    label: '1475 IPFS',
    linkLabel: '1475ipfs.com',
    scaleNum: 1.4
  },
  {
    img: require("./assets/logos/2x/Kronos.png"),
    label: 'kronos',
    linkLabel: 'woo.trade',
    scaleNum: 1.4
  },
  {
    img: require("./assets/logos/2x/crypto.png"),
    label: 'crypto briefing',
    linkLabel: 'cryptobriefing.com',
    scaleNum: 1.3
  },
  {
    img: require("./assets/logos/2x/BTCMedia.png"),
    label: 'btc media',
    linkLabel: 'btcmedia.org',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/DapperLabs.png"),
    label: 'dapper labs',
    linkLabel: 'dapperlabs.com',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/AlphaWallet.png"),
    label: 'Alpha Wallet',
    linkLabel: 'alphawallet.com',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/Radicle.png"),
    label: 'radicle',
    linkLabel: 'radicle.xyz',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/Torus.png"),
    label: 'torus',
    linkLabel: 'tor.us',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/Longhash.png"),
    label: 'longhash',
    linkLabel: 'longhash.com/en',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/Hpool.png"),
    label: 'hpool',
    linkLabel: 'hpool.com',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/mykey.png"),
    label: 'mykey',
    linkLabel: 'mykey.org',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/kusama.png"),
    label: 'kusama.network',
    linkLabel: 'kusama.network'
  },
  {
    img: require("./assets/logos/2x/Sygnum.png"),
    label: 'sygnum',
    linkLabel: 'sygnum.com',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/Verady.png"),
    label: 'verady',
    linkLabel: 'verady.com',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/YellowCard.png"),
    label: 'yellow card',
    linkLabel: 'yellowcard.io',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/Deepcoin.png"),
    label: 'deepcoin',
    linkLabel: 'deepcoin.com',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/heyuetek.png"),
    label: 'heyuetek',
    linkLabel: 'heyuetek.com',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/BlockDaemon.png"),
    label: 'blockDaemon',
    linkLabel: 'blockdaemon.com',
    scaleNum: 1.5
  },
  {
    img: require("./assets/logos/2x/Juzix.png"),
    label: 'juzix',
    linkLabel: 'juzix.net',
    scaleNum: 1.6
  },
  {
    img: require("./assets/logos/2x/tierion.png"),
    label: 'tierion',
    linkLabel: 'tierion.com',
    scaleNum: 1.3
  },
  //
  // {
  //   img: require("assets/logos/2x/airbloc.png"),
  //   label: 'airbloc',
  //   linkLabel:'airbloc.org'
  // },
  // {
  //   img: require("assets/logos/2x/alchemint.png"),
  //   label: 'alchemint',
  //   linkLabel:'alchemint.io'
  // },
  // {
  //   img: require("assets/logos/2x/alphacat.png"),
  //   label: 'alphacat',
  //   linkLabel:'alphacat.io'
  // },

  // {
  //   img: require("assets/logos/2x/carblock.png"),
  //   label: 'carblock',
  //   linkLabel:'carblock.io'
  // },


  // {
  //   img: require("assets/logos/2x/charter.png"),
  //   label: 'charter',
  //   linkLabel:'charter.foundation'
  // },
  // {
  //   img: require("assets/logos/2x/coalpha.png"),
  //   label: 'coalpha',
  //   linkLabel:'coalpha.ai'
  // },
  // {
  //   img: require("assets/logos/2x/coinmex.png"),
  //   label: 'coinmex',
  //   linkLabel:'coinmex.io'
  // },
  // {
  //   img: require("assets/logos/2x/compassx.png"),
  //   label: 'compassx',
  //   linkLabel:'compassx.com'
  // },
  // {
  //   img: require("assets/logos/2x/cybex.png"),
  //   label: 'cybex',
  //   linkLabel:'cybex.io'
  // },

  // //d
  // {
  //   img: require("assets/logos/2x/delphy.png"),
  //   label: 'delphy',
  //   linkLabel:'delphy.org'
  // },
  // {
  //   img: require("assets/logos/2x/dxchain.png"),
  //   label: 'dxchain',
  //   linkLabel:'dxchain.com'
  // },
  // {
  //   img: require("assets/logos/2x/egretia.png"),
  //   label: 'egretia',
  //   linkLabel:'egretia.io'
  // },
  // {
  //   img: require("assets/logos/2x/enotes.png"),
  //   label: 'enotes',
  //   linkLabel:'#'
  // },


  // {
  //   img: require("assets/logos/2x/hacken.png"),
  //   label: 'hacken',
  //   linkLabel:'hacken.io'
  // },
  // {
  //   img: require("assets/logos/2x/hashgard.png"),
  //   label: 'hashgard',
  //   linkLabel:'hashgard.io'
  // },
  // {
  //   img: require("assets/logos/2x/heronode.png"),
  //   label: 'heronode',
  //   linkLabel:'heronode.io'
  // },

  // {
  //   img: require("assets/logos/2x/laya.png"),
  //   label: 'laya',
  //   linkLabel:'laya.one'
  // },
  // {
  //   img: require("assets/logos/2x/lifewow.png"),
  //   label: 'lifewow',
  //   linkLabel:'lifewow.io'
  // },


  // {
  //   img: require("assets/logos/2x/merculet.png"),
  //   label: 'merculet',
  //   linkLabel:'merculet.io'
  // },
  // {
  //   img: require("assets/logos/2x/mytoken.png"),
  //   label: 'mytoken',
  //   linkLabel:'mytoken.io'
  // },
  // {
  //   img: require("assets/logos/2x/nebula.png"),
  //   label: 'nebula',
  //   linkLabel:'nbltrust.com'
  // },
  // {
  //   img: require("assets/logos/2x/nns.png"),
  //   label: 'nns',
  //   linkLabel:'neons.name'
  // },


  // {
  //   img: require("assets/logos/2x/plair.png"),
  //   label: 'plair',
  //   linkLabel:'plair.life'
  // },

  // {
  //   img: require("assets/logos/2x/rate3.png"),
  //   label: 'rate3',
  //   linkLabel:'rate3.network'
  // },
  // {
  //   img: require("assets/logos/2x/RRchain.png"),
  //   label: 'RRchain',
  //   linkLabel:'rrchain.network'
  // },
  // {
  //   img: require("assets/logos/2x/taraxa.png"),
  //   label: 'taraxa',
  //   linkLabel:'taraxa.io'
  // },

  // {
  //   img: require("assets/logos/2x/themis.png"),
  //   label: 'themis',
  //   linkLabel:'themis.network'
  // },
  // {
  //   img: require("assets/logos/2x/tierion.png"),
  //   label: 'tierion',
  //   linkLabel:'tierion.com'
  // },
  // {
  //   img: require("assets/logos/2x/Valpromise.png"),
  //   label: 'Valpromise',
  //   linkLabel:'valp.io'
  // },

  // {
  //   img: require("assets/logos/2x/dispatchlabs.png"),
  //   label: 'DISPATCH',
  //   linkLabel:'dispatchlabs.io'
  // },
  // {
  //   img: require("assets/logos/2x/lots.png"),
  //   label: 'lots',
  //   linkLabel:'lots.org'
  // }

]
export default json



// WEBPACK FOOTER //
// ./src/logos.js